module.exports = __webpack_public_path__ + "static/media/ic_add.641a95c6.svg";